import * as tslib_1 from "tslib";
import React from 'react';
import Transition from 'react-transition-group/Transition';
import StyledRipple from './StyledRipple';
import RippleWrapper from './RippleWrapper';
var Ripple = /** @class */ (function (_super) {
    tslib_1.__extends(Ripple, _super);
    function Ripple(props) {
        var _this = _super.call(this, props) || this;
        _this.handleEnter = function () {
            _this.setState({
                rippleVisible: true,
            });
        };
        _this.handleExit = function () {
            _this.setState({
                rippleLeaving: true,
            });
        };
        _this.state = {
            rippleVisible: false,
            rippleLeaving: false,
        };
        return _this;
    }
    Ripple.prototype.render = function () {
        var _a = this.props, pulsate = _a.pulsate, rippleX = _a.rippleX, rippleY = _a.rippleY, rippleSize = _a.rippleSize, other = tslib_1.__rest(_a, ["pulsate", "rippleX", "rippleY", "rippleSize"]);
        var rippleStyles = {
            width: rippleSize,
            height: rippleSize,
            top: -(rippleSize / 2) + rippleY,
            left: -(rippleSize / 2) + rippleX,
        };
        return (React.createElement(Transition, tslib_1.__assign({ onEnter: this.handleEnter, onExit: this.handleExit }, other),
            React.createElement(RippleWrapper, { leaving: this.state.rippleLeaving, pulsating: this.props.pulsate },
                React.createElement(StyledRipple, { visible: this.state.rippleVisible, fast: this.props.pulsate, style: rippleStyles }))));
    };
    Ripple.defaultProps = {};
    return Ripple;
}(React.Component));
export default Ripple;
//# sourceMappingURL=Ripple.js.map